package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.icons.fa.FaAlignCenter
import com.varabyte.kobweb.silk.components.icons.fa.FaAlignJustify
import com.varabyte.kobweb.silk.components.icons.fa.FaAlignLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaAlignRight

enum class TextAlignment(
    val iconPath: String,
    val label: String
) {
    LEFT(
        iconPath = "/align-left.svg",
        label = "Aligner à gauche"),
    CENTER(
        iconPath = "/align-center.svg",
        label = "Centrer"),
    RIGHT(
        iconPath = "/align-right.svg",
        label = "Aligner à droite"
    ),
    JUSTIFY(
        iconPath = "/align-justify.svg",
        label = "Justifier"
    );

    @Composable
    fun Icon(modifier: Modifier = Modifier) {
        when (this) {
            LEFT    -> FaAlignLeft(modifier = modifier)
            CENTER  -> FaAlignCenter(modifier = modifier)
            RIGHT   -> FaAlignRight(modifier = modifier)
            JUSTIFY -> FaAlignJustify(modifier = modifier)
        }
    }
}